<app-mdr-title
    class="dashboard-box-title d-flex m-b-20"
    fontSize="16"
    >{{ element[0].title }}
    <!--        <span *ngIf="widget.error"-->
    <!--              class="ds-icon-error_outline_black_24dp fs-25 error-primary m-l-8"-->
    <!--              style="line-height: 0.8"></span>-->
</app-mdr-title>

@if (loadedData.length === element.length) {
<div class="d-flex-center flex-flow-wrap justify-space-around">
    @for (chart of loadedData; track chart; let chartIndex = $index) {
    <div
        [class]="'width-' + containerWidth"
        id="{{ element[chartIndex].id }}"
        class="d-flex-center flex-direction-column align-self-start"
    >
        <!--        NORMAL STATE-->
        @if (chart.response) { @if (chart.response && chart.response.data) { @if (chart.response && chart.response.data) {
        <div
            class="gauge"
            [class]="'width-' + width"
        >
            <div class="gauge--wrapper">
                @if (chart.delimitation) {
                <div class="gauge--labels-container w-100 h-100">
                    <span class="step step--1 width-2 height-20"></span>
                    <span class="step step--2 width-2 height-20"></span>
                    <span class="step step--3 width-2 height-20"></span>
                </div>
                }
                <div class="gauge--value fs-48 d-flex-center justify-center flex-direction-column m-t-20">
                    @if (chart.response.data.chip) {
                    <mat-chip
                        disableRipple
                        class="gauge--value--delta-chip d-flex-center m-b-5"
                    >
                        @if (mdrDashboardsService.statusOfDeploymentValue && mdrDashboardsService.statusOfDeploymentValue.currentStatus ===
                        mdrDashboardsService.statusOfDeploymentValue.total) {
                        <span class="display-1 fs-12"> Active </span>
                        } @if (mdrDashboardsService.statusOfDeploymentValue && mdrDashboardsService.statusOfDeploymentValue.currentStatus
                        !== mdrDashboardsService.statusOfDeploymentValue.total) {
                        <span class="display-1 fs-12"> Deploying </span>
                        }
                    </mat-chip>
                    }
                    <span class="display-1 fs-53 m-b-5">
                        {{ processReceivedData(chart.response.data, chartIndex) }}
                    </span>
                    <span class="radial-bar--label fs-16">
                        {{ chart.response.data.label || '- -' }}
                    </span>
                </div>
                <svg
                    [attr.style]="markerStyles[chartIndex]"
                    class="marker"
                    viewBox="0 1.5 100 50"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <defs>
                        <marker
                            id="dot"
                            viewBox="0 0 10 10"
                            refX="4"
                            refY="4"
                            markerWidth="3"
                            markerHeight="3"
                        >
                            <circle
                                cx="4"
                                cy="4"
                                r="4"
                                fill="white"
                            />
                        </marker>
                    </defs>
                    <g>
                        <line
                            id="marker"
                            x1="5"
                            y1="50"
                            x2="48"
                            y2="50"
                            stroke="none"
                            stroke-width="1"
                            marker-start="url(#dot)"
                        ></line>
                    </g>
                </svg>
                <svg
                    class="outer-wrapper"
                    viewBox="0 0 100 50"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <defs>
                        <linearGradient
                            [id]="'gradient' + chartIndex"
                            y1="71.67"
                            x2="143.21"
                            y2="71.67"
                            gradientUnits="userSpaceOnUse"
                        >
                            @for (color of chart.chart.colors; track color; let i = $index) {
                            <stop
                                [attr.offset]="processLineColor(color, i)"
                                [style]="{ 'stop-color': color }"
                            />
                            }
                        </linearGradient>
                    </defs>
                    <g
                        fill-opacity="0"
                        stroke-width="10"
                    >
                        <path
                            class="outer"
                            d="M5 50a45 45 0 1 1 90 0"
                            [attr.stroke-width]="strokeWidth"
                        />
                        <path
                            id="gauge"
                            class="gauge-progress"
                            d="M5 50a45 45 0 1 1 90 0"
                            [attr.stroke-width]="strokeWidth"
                            [attr.stroke-dasharray]="dashArray[chartIndex]"
                            [attr.stroke-dashoffset]="dashOffset[chartIndex]"
                            [attr.stroke]="'url(#gradient' + chartIndex + ')'"
                        />
                    </g>
                </svg>
            </div>
        </div>
        } @if (chart.response.data && tableLegend) {
        <div
            class="full-width m-t-40"
            id="{{ element[chartIndex].id }}_legend"
        >
            @if (chartIndex === 0 && organization && organization.onboarding_issue && loadedCompany) {
            <div class="inline-block onboarding-issue-container p-10 w-100 m-t--10">
                <span class="error-icon inline-block fs-24 ds-icon-notification_negative"></span>
                <p class="inline-block gauge-table-category--name fs-12">
                    {{ translateIssue(organization.onboarding_issue) }}
                </p>
            </div>
            } @for (category of chart.response.data.data; track category) {
            <div
                class="gauge-table-category d-flex justify-space-between"
                [ngStyle]="{ 'flex-direction': 'row', 'align-items': 'center !important' }"
            >
                <p class="gauge-table-category--name fs-12">{{ category.name }}</p>
                @if (category.started_on) {
                <mat-icon class="d-flex-center justify-center gauge-table-category--icon fs-18"> done </mat-icon>
                }
            </div>
            }
        </div>
        } }
        <!--ERROR STATE-->
        @if (chart.response.error) {
        <div
            class="gauge"
            [class]="'width-' + width"
            id="{{ element[chartIndex].id }}_error"
        >
            <div class="gauge--wrapper">
                @if (chart.delimitation) {
                <div class="gauge--labels-container w-100 h-100">
                    <span class="step step--1"></span>
                    <span class="step step--2"></span>
                    <span class="step step--3"></span>
                </div>
                }
                <div class="gauge--value d-flex-center fs-48 text-center justify-center flex-direction-column m-t-20">
                    <span class="display-1 fs-53 m-b-5">
                        {{ processReceivedData(chart.response.data, chartIndex) }}
                    </span>
                    <span class="radial-bar--label fs-16">
                        {{ '...' }}
                    </span>
                </div>
                <svg
                    [attr.style]="markerStyles[chartIndex]"
                    class="marker"
                    viewBox="0 1.5 100 50"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <defs>
                        <marker
                            id="dot"
                            viewBox="0 0 10 10"
                            refX="4"
                            refY="4"
                            markerWidth="3"
                            markerHeight="3"
                        >
                            <circle
                                cx="4"
                                cy="4"
                                r="4"
                                fill="white"
                            />
                        </marker>
                    </defs>
                    <g>
                        <line
                            id="marker"
                            x1="5"
                            y1="50"
                            x2="48"
                            y2="50"
                            stroke="none"
                            stroke-width="1"
                            marker-start="url(#dot)"
                        ></line>
                    </g>
                </svg>
                <svg
                    class="outer-wrapper"
                    viewBox="0 0 100 50"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <defs>
                        <linearGradient
                            [id]="'gradient' + chartIndex"
                            y1="71.67"
                            x2="143.21"
                            y2="71.67"
                            gradientUnits="userSpaceOnUse"
                        >
                            @for (color of chart.chart.colors; track color; let i = $index) {
                            <stop
                                [attr.offset]="processLineColor(color, i)"
                                [style]="{ 'stop-color': color }"
                            />
                            }
                        </linearGradient>
                    </defs>
                    <g
                        fill-opacity="0"
                        stroke-width="10"
                    >
                        <path
                            class="outer"
                            d="M5 50a45 45 0 1 1 90 0"
                            [attr.stroke-width]="strokeWidth"
                        />
                        <path
                            id="gauge"
                            class="gauge-progress"
                            d="M5 50a45 45 0 1 1 90 0"
                            [attr.stroke-width]="strokeWidth"
                            [attr.stroke-dasharray]="dashArray[chartIndex]"
                            [attr.stroke-dashoffset]="dashOffset[chartIndex]"
                            [attr.stroke]="'url(#gradient' + chartIndex + ')'"
                        />
                    </g>
                </svg>
            </div>
        </div>
        <div class="widget-error-container d-flex-center justify-center">
            <span class="ds-icon-notification_negative error-icon fs-28 p-10"></span>
            <div>
                <p class="widget-error-container--title text-left fs-12 m-0 p-2">Error</p>
                <p class="widget-error-container--description text-left fs-12 m-0 p-2">Couldn't retrieve data</p>
            </div>
        </div>
        @if (tableLegend) {
        <div class="full-width m-t-40">
            @for (category of defaultCategoriesIterator; track category) {
            <div class="gauge-table-category d-flex-center justify-space-between">
                <p class="gauge-table-category--name fs-12">{{ '...' }}</p>
            </div>
            }
        </div>
        } }
        <!--            LOADING STATE-->
        @if (chart.response.loading) {
        <app-mdr-loader
            [ngClass]="chart.response.loading ? 'widget-empty' : 'widget-loading'"
            class="center-loader full-width"
            [rows]="10"
            [columns]="1"
        ></app-mdr-loader>
        } }
    </div>
    }
</div>
}
